import { render, staticRenderFns } from "./releaseNumberConfig.vue?vue&type=template&id=6e2f6686&"
import script from "./releaseNumberConfig.vue?vue&type=script&lang=js&"
export * from "./releaseNumberConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e2f6686')) {
      api.createRecord('6e2f6686', component.options)
    } else {
      api.reload('6e2f6686', component.options)
    }
    module.hot.accept("./releaseNumberConfig.vue?vue&type=template&id=6e2f6686&", function () {
      api.rerender('6e2f6686', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/releaseNumberConfig.vue"
export default component.exports